// @ts-check
import { useSyncExternalStore } from "react";

/**
 * Observa uma media query CSS.
 *
 * Usa `useSyncExternalStore` em vez de `useState` + `useEffect`: o valor
 * lido na primeira renderização já é o correto, sem o "pisca" de layout
 * que aparece quando o estado só se ajusta depois de montar.
 *
 * @param {string} query ex.: "(max-width: 767px)"
 */
export function useMediaQuery(query) {
  return useSyncExternalStore(
    (callback) => {
      const lista = window.matchMedia(query);
      lista.addEventListener("change", callback);
      return () => lista.removeEventListener("change", callback);
    },
    () => window.matchMedia(query).matches,
    () => false, // valor no servidor / antes da hidratação
  );
}

/** Atalho para o breakpoint usado nas telas. */
export const useIsMobile = () => useMediaQuery("(max-width: 767px)");
